(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-profile-image', [
      'kareo.ui.shared.modules.authentication.k-roles'
    ])
    .directive('kUserProfileImage', kUserProfileImage);

  kUserProfileImage.$inject = ['K_ROLES'];
  function kUserProfileImage(K_ROLES) {
    return {
      bindToController: {
        defaultImage: '@?',
        user: '<kUserProfileImage'
      },
      controller() {},
      controllerAs: 'kUPI',
      link,
      restrict: 'A'
    };

    function link(scope, element, attrs, kUPI) {
      init();

      // ----------

      function init() {
        element.on('abort', useDefaultImage);
        element.on('error', useDefaultImage);
        loadImage();
        scope.$watch('kUPI.user', loadImage);
      }

      function loadImage() {
        element.unbind('load', verifyImage);

        if (!!kUPI.user && !!kUPI.user.userGuid) {
          loadUserImage(kUPI.user.userGuid);
        } else {
          useDefaultImage();
        }
      }

      function loadUserImage(userGuid) {
        var imageUrl = '/common-ui/api/User/profileImage/' + userGuid;

        element.attr('src', imageUrl);

        element.one('load', verifyImage);
      }

      function useDefaultImage() {
        var isProvider = kUPI.user.roles.indexOf(K_ROLES.PROVIDER) >= 0;
        if (!!kUPI.defaultImage) {
          element.attr('src', kUPI.defaultImage);
        } else if (isProvider) {
          element.attr('src',
            '/shared-assets-ui/bundle/css/img/chrome/persona/provider-light-bg.svg');
        } else {
          element.attr('src',
            '/shared-assets-ui/bundle/css/img/chrome/persona/staff-light-bg.svg');
        }
      }

      function verifyImage() {
        var img = this;
        if (!img.naturalHeight || !img.naturalWidth) {
          useDefaultImage();
        }
      }
    }
  }
})();
